import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

class FocusEvent extends EventData<Focusable> {

}

class FocusEventListener extends EventListener<Focusable, FocusEvent, any> {
  constructor() {
    super(FocusEvent);
  }
}

export default interface Focusable extends Mountable {

  /** @event */
  onBlur: FocusEventListener;

  /** @event */
  onFocus: FocusEventListener;

}

export { FocusEventListener, FocusEvent };
